import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconBook = createIcon({
  displayName: 'IconBook',
  path: [
    <path
      key="0"
      d="M21 21H3V3H10V12.13L12 10.8L14 12.13V3H21V5H16V15.87L12 13.2L8 15.87V5H5V19H19V7H21V21Z"
      fill="currentColor"
    />,
  ],
  viewBox: '0 0 24 24',
})
